/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

/**
 *
 * @namespace classes.NumberHelper
 */
const NumberHelper = /** @lends classes.NumberHelper*/ {
  /**
   * Check if a string is an Integer
   * @param {string} str - string to be tested
   * @returns {boolean} true if str is an Integer
   */
  isStringInteger: function (str) {
    return Number.isInteger(Number.parseInt(str, 10));
  },

  /**
   * Decode an integer in Big-Endian binary notation
   * and store it into a JavaScript native integer.
   * Truncate the value parameter if longer than 4 bytes.
   * @param {string}  value the integer in BE binary notation
   * @returns {number} the integer in JavaScript native integer
   */
  decodeInteger: function (value) {
    if (value.length > 4) {
      value = value.substring(0, 4);
    }
    let ret = "";
    for (let i = 0; i < value.length; ++i) {
      let hex = value.codePointAt(i).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      ret += hex;
    }
    return Number.parseInt(ret, 16);
  },

  /**
   * Encode a JavaScript native integer and store it
   * into an integer in Big-Endian binary notation.
   * Truncate the value parameter if longer than 4 bytes.
   * (the VM protocol's header only handles 4 bytes integer)
   * @param {number} value the integer as JavaScript native integer
   * @returns {string} the integer in BE binary notation
   */
  encodeInteger: function (value) {
    let result = value.toString(16);
    if (result.length > 8) {
      result = result.substring(result.length - 8, result.length);
    } else if (result.length < 8) {
      while (result.length < 8) {
        result = "0" + result;
      }
    }
    const valueArr = result.match(/.{2}/g);
    for (let i = 0; i < valueArr.length; ++i) {
      valueArr[i] = String.fromCodePoint(Number.parseInt(valueArr[i], 16));
    }
    result = valueArr.join("");
    return result;
  },

  compare: function (a, b) {
    if (a === b) {
      return 0;
    }
    if (a < b) {
      return -1;
    }
    return 1;
  }
};

modulum("NumberHelper", function (context, cls) {
  cls.NumberHelper = NumberHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = NumberHelper;
}
